import { http } from '@pendo/http';
import get from 'lodash/get';
import moment from '@/utils/moment-wrapper.ts';
import { i18n_t as $t } from '@/utils/i18n';

export const DEFAULT_PLAYLIST_ICON = 'play-circle';

export const DEFAULT_PLAYLIST_ICON_COLOR = '#9A9CA5';

export function getPlaylists (createdByMe = true) {
    const params = { createdByMe };

    return http.get('/api/s/_SID_/playlist', { params }).then((res) => res.data);
}

export function getPlaylistById (id, abortSignal) {
    return http.get(`/api/s/_SID_/playlist/${id}`, { signal: abortSignal }).then((res) => res.data);
}

export function updatePlaylist (playlist) {
    return http.put(`/api/s/_SID_/playlist/${playlist.id}`, playlist).then((res) => res.data);
}

export function bulkModifyPlaylists (modifyPlaylistsBody) {
    return http.put('/api/s/_SID_/playlist', modifyPlaylistsBody).then((res) => res.data);
}

export function createPlaylist (playlist, activeSub) {
    if (!get(playlist, 'title')) {
        playlist.title = $t('playlistsUtils.Unnamed {date} {timeZoneAbbrev}', {
            date: moment(Date.now()).format('@ h:mm A'),
            timeZoneAbbrev: activeSub.timeZoneAbbrev,
        });
    }

    if (!get(playlist, 'definition')) {
        playlist.definition = {
            playlistIcon: DEFAULT_PLAYLIST_ICON,
            playlistColor: DEFAULT_PLAYLIST_ICON_COLOR,
        };
    }

    return http.post('/api/s/_SID_/playlist', playlist).then((res) => res.data);
}

export function deletePlaylist (id) {
    return http.delete(`/api/s/_SID_/playlist/${id}`);
}

export function getPlaylistsOfClip (clipId) {
    return http.post('/api/s/_SID_/playlist/itemid', { itemId: clipId, type: 'clip' }).then((res) => res.data);
}
